module.exports = __webpack_public_path__ + "static/media/customers.ea1c14dc.jpg";